import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

export const trackContentPlacementsTest = (): void => {
    trackAbTestV2Variant('Homepage_ContentPlaements_July2025');
};
